const stadistics = {
  backbtn: "Geh zurück",
  pumpHousingC: "Pumpengehäusetemperatur (° C)",
  pumpHousingF: "Pumpengehäusetemperatur (° F)",
  mapCFSBar11: "API 11 Kupplungsseiter und Lagerseiter Seitendruck (bar)",
  mapSHTc: "API 23 Stopfbuchsraumn-Temperatur (° F)",
  mapSHPbar: "API 23 Stopfbuchsraumndruck (bar)",
  mapFITc: "API 23 FI Temperatur (° C)",
  mapCwTc: "API 23 Kühlwassertemperatur ein - aus (° C)",
  mapfCTc: "API 32 Lagerseite und Kupplunseitentemperatur (° C)",
  mapfCbar: "API 32 Lagerseiter und Kupplungsseiter Seitendruck (bar)",
  mapCwInOut52: "API 52 Kühlwassertemperatur rein und raus (° C)",
  mapOilInOut52: "API 52 Öltemperatur (° C) rein und raus",
  mapShPbar52: "API 52 Stopfbuchsraumndruck (bar)",
  mapPBar52: "API 52 Druck (bar)",
  mapTankLevel52: "API 52 Tankfüllstand (mm)",
  mapIaPbar53b: "API 53b Instrumentenluftdruck (bar)",
  mapSysPbar53b: "API 53b Systemdruck (bar)",
  mapcBpiBpoTc53b: "API 53b Kupplungsseite Bpi Bpo-Temperatur (° C)",
  mapfBpiBpoTc53b: "API 53b Lagerseite Bpi Bpo Temperatur (° C)",
  mapcBpiBpoBar53b:
    "API 53b Lagerseiter und Kupplungsseiter seitlicher Bpo-Druck (bar)",
  mapfBpiBpoBar53b: "API 53b Lagerseiter Bpi Bpo Druck (Bar)",
  mapcCwInOut53b: "API 53b In Board Cooling Water In Out Temperature (°C)",
  mapfCwInOut53b: "API 53b Lagerseite Kühlwassereintrittstemperatur (° C)",
  mapFCRs53b:
    "API 53b Nachfüllsysteme gekoppelt und unter Lagerseitem Druck (bar)",
  mapBpiBpoTc54:
    "API 54 Kupplungsseite seitliche BPI- und BPO-Temperatur (° C)",
  mapBpiBpoPbar54: "API 54 In Board BPI - BPO-Druck (bar)",
  mapCwInOut54:
    "API 54 Temperatur des Kupplungsseiten seitlichen Kühlwassers ein und aus (° C)",
  mapFlowL54: "API 54 Kupplungsseiter Seitenstrom (l / min)",
  mapMotorTc54: "API 54 Temperatur des Kupplungsseiten Seitenmotors (° C)",
  mapTankLevel54: "API 54 Kupplungsseiter Seitentankfüllstand (mm)",
  mapfBpiBpoTc54: "API 54 Out Board BPI und BPO Temperatur (° C)",
  mapfBpiBpoPbar54: "API 54 Out Board BPI - BPO-Druck (bar)",
  mapfCwInOut54: "API 54 Lagerseite Kühlwassertemperatur rein und raus (° C)",
  mapfFlowL54: "API 54 Lagerseiter Seitenfluss (l / min)",
  mapfMotorTc54: "API 54 Lagerseite Motortemperatur (° C)",
  mapfTankLevel54: "API 54 Lagerseiter Seitentankfüllstand (mm)",
  imapPumpHousing: "Pumpengehäusetemperatur (° F)",
  imapCFSpsi11: "API 11 Kupplungsseiter und Lagerseiter Seitendruck (psi)",
  imapSHTc: "API 23 Stopfbuchsraumn-Temperatur (° F)",
  imapSHPbar: "API 23 Stuffing Box Pressure (psi)",
  imapFITc: "API 23 FI-Temperatur (° F)",
  imapCwTc: "API 23 Kühlwassertemperatur ein - aus (° F)",
  imapfCTf: "API 32 Lagerseite und Kupplunseitentemperatur (° F)",
  mapfCpsi: "API 32 Lagerseiter und Kupplungsseiter Seitendruck (psi)",
  imapCwInOut52: "API 52 Kühlwassertemperatur rein und raus (° OF)",
  imapOilInOut52: "API 52 Öltemperatur (° F) rein und raus",
  imapShPbar52: "API 52 Stopfbuchsraumndruck (psi)",
  imapPBar52: "API 52 Druck (psi)",
  imapTankLevel52: "API 52 Tankfüllstand (mm)",
  imapIaPbar53b: "API 53b Instrumentenluftdruck (psi)",
  imapSysPbar53b: "API 53b Systemdruck (psi)",
  imapcBpiBpoTc53b: "API 53b Kupplungsseite Bpi Bpo-Temperatur (° F)",
  imapfBpiBpoTc53b: "API 53b Lagerseite Bpi Bpo Temperatur (° F)",
  imapcBpiBpoBar53b:
    "API 53b Lagerseiter und Kupplungsseiter seitlicher Bpo-Druck (psi)",
  imapfBpiBpoBar53b: "API 53b Out Board Bpo-Druck (psi)",
  imapcCwInOut53b: "API 53b Kupplungsseite Kühlwassereintrittstemperatur (° F)",
  imapfCwInOut53b: "API 53b Lagerseite Kühlwassereintrittstemperatur (° F)",
  imapFCRs53b:
    "API 53b Nachfüllsysteme gekoppelt und unter Lagerseitem Druck (psi)",
  imapBpiBpoTc54:
    " API 54 Kupplungsseite seitliche BPI- und BPO-Temperatur (° F)",
  imapBpiBpoPbar54: "API 54 Kupplungsseiter seitlicher BPI - BPO-Druck (psi)",
  imapCwInOut54:
    "API 54 Temperatur des Kupplungsseiten seitlichen Kühlwassers ein und aus (° F)",
  imapFlowL54: "API 54 Kupplungsseiter Seitenstrom (gal / min)",
  imapMotorTc54: "API 54 Temperatur des Kupplungsseiten Seitenmotors (° F)",
  imapTankLevel54: "API 54 Gefüllter Seitentankfüllstand (l)",
  imapfBpiBpoTc54: "API 54 Out Board BPI und BPO Temperatur (° F)",
  imapfBpiBpoPbar54: "API 54 Out Board BPI - BPO-Druck (psi)",
  imapfCwInOut54: "API 54 Lagerseite Kühlwassertemperatur rein und raus (° F)",
  imapfFlowL54: "API 54 Lagerseiter Seitenfluss (gal / min)",
  imapfMotorTc54: "API 54 Lagerseite Motortemperatur (° F)",
  imapfTankLevel54: "API 54 Tankfüllstand auf der Lagerseiten Seite (l)",
  commentList: "Kommentarliste",
  inspectionDate: "Inspektionsdatum",
  comment: "Kommentar"
};
export default stadistics;
